import React from 'react';

import { Frequency, rrulestr } from 'rrule';

import { isWeekdayPattern } from '../../ScheduleDetails/utils/rruleUtils';

const getFrequencyLabel = (freq: Frequency, interval: number): string => {
  const labels: Record<Frequency, string> = {
    [Frequency.YEARLY]: 'Annually',
    [Frequency.MONTHLY]: 'Monthly',
    [Frequency.WEEKLY]: 'Weekly',
    [Frequency.DAILY]: 'Daily',
    [Frequency.HOURLY]: 'Hourly',
    [Frequency.MINUTELY]: 'Every minute',
    [Frequency.SECONDLY]: 'Every second',
  };

  const label = labels[freq] || 'One off';

  if (interval > 1) {
    const pluralLabels: Record<Frequency, string> = {
      [Frequency.YEARLY]: `Every ${interval} years`,
      [Frequency.MONTHLY]: `Every ${interval} months`,
      [Frequency.WEEKLY]: `Every ${interval} weeks`,
      [Frequency.DAILY]: `Every ${interval} days`,
      [Frequency.HOURLY]: `Every ${interval} hours`,
      [Frequency.MINUTELY]: `Every ${interval} minutes`,
      [Frequency.SECONDLY]: `Every ${interval} seconds`,
    };
    return pluralLabels[freq] || label;
  }

  return label;
};

export const frequencyRenderer = ({ value }: { value: string }): React.ReactNode => {
  if (!value) {
    return <p>One off</p>;
  }

  try {
    const rrule = rrulestr(value);
    const { freq, interval = 1, count, byweekday } = rrule.options;

    if (count === 1) {
      return <p>One off</p>;
    }

    if (isWeekdayPattern(freq, byweekday)) {
      return <p>Every weekday</p>;
    }

    return <p>{getFrequencyLabel(freq, interval)}</p>;
  } catch {
    return <p>One off</p>;
  }
};
